<script lang="ts">
  interface Props {
    name?: string
    class?: string
  }

  let { name = '', class: className = '' }: Props = $props()

  /** Генерация псевдослучайного оттенка зелёного по имени товара */
  function hueFromName(s: string): number {
    let h = 0
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 360
    return 90 + (h % 40) // диапазон 90–130 (жёлто-зелёный)
  }

  const hue = $derived(hueFromName(name))
</script>

<div
  class="relative flex h-full w-full items-center justify-center overflow-hidden bg-[#111d12] {className}"
  aria-label={name || 'Фото товара'}
>
  <svg
    class="absolute inset-0 h-full w-full"
    viewBox="0 0 320 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <!-- Фон -->
    <rect width="320" height="240" fill="#111d12" />

    <!-- Декоративные круги -->
    <circle cx="160" cy="120" r="80" fill="rgba(122,181,71,0.04)" />
    <circle cx="160" cy="120" r="55" fill="rgba(122,181,71,0.06)" />

    <!-- Иконка листика -->
    <g transform="translate(120, 60)">
      <!-- Стебель -->
      <path d="M40 140 Q40 80 40 40" stroke="rgba(122,181,71,0.4)" stroke-width="3" stroke-linecap="round" />
      <!-- Лист левый -->
      <path
        d="M40 100 Q10 70 20 40 Q50 60 40 100z"
        fill="rgba(122,181,71,0.25)"
        stroke="rgba(122,181,71,0.4)"
        stroke-width="1"
      />
      <!-- Лист правый -->
      <path
        d="M40 80 Q70 55 60 30 Q30 45 40 80z"
        fill="rgba(122,181,71,0.3)"
        stroke="rgba(122,181,71,0.5)"
        stroke-width="1"
      />
      <!-- Макушка -->
      <path
        d="M40 40 Q25 20 35 5 Q55 20 40 40z"
        fill="rgba(122,181,71,0.5)"
        stroke="rgba(122,181,71,0.7)"
        stroke-width="1"
      />
    </g>

    <!-- Название (первые буквы) -->
    {#if name}
      <text
        x="160"
        y="212"
        text-anchor="middle"
        font-family="system-ui, sans-serif"
        font-size="11"
        fill="rgba(122,181,71,0.4)"
        letter-spacing="0.05em"
      >
        {name.length > 18 ? name.slice(0, 18) + '…' : name}
      </text>
    {/if}
  </svg>
</div>
